import styled from "styled-components";

export const SelectInputContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const SelectContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;

export const RootContainer = styled.div`
  width: 100%;
`;
